import React from "react";
import InfiniteScroll from 'react-infinite-scroller';

import {
    TableCell,
    TableRow,
} from '@material-ui/core';

import { 
    Row,
    Col,
    Form,
    Button,
    Dropdown,
    Badge,
    Spinner,
} from "react-bootstrap-v5";
import styled from 'styled-components';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { ReactComponent as LightbulbIcon } from '../../../../_metronic/assets/img/icons/material-lightbulb-outline.svg';

import Utils from "../../../utils/utils";
import { PageCookieSettingType, SortColumns, PagesPermissions } from "../../../utils/enums";

import WrappedButton from '../../../components/Buttons/WrappedButton';
import DropdownToggle from '../../../components/dropdown/DropdownToggle';
import SearchDialog from '../../../components/dialog/SearchDialog';
import Popup from '../../../components/popup/Popup';
import CustomTooltip from '../../../components/Tooltip/Tooltip';
import LoadingButton from '../../../components/Buttons/LoadingButton';
import makeDropdownList from "../../../components/dropdown/makeDropdownList";
import DataTableActionMenu from '../../../components/OLD/DataTable/DataTableActionMenu';
import DataTable from "../../../components/OLD/DataTable/DataTable";
import DataTableAjaxPagination from '../../../components/OLD/DataTable/Pagination/DataTableAjaxPaginationV5';
import DataTableScrollSync from '../../../components/OLD/DataTable/DataTableScrollSync.jsx';
import IconButtonTable from "../../../components/Buttons/IconButtonTable";
import IconButtonSearch from '../../../components/input/IconButtonSearch';

import ViewTopSection from "../partial/ViewTopSection";

import CustomerForm from "./CustomerForm";
import LocalServiceForm from "./LocalServiceForm";

import { readApi } from '../../../api/CRUD/DispatchCRUD'

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { actions } from "../../../../setup/redux/auth/saga";
import { dispatchApiCallGet, dispatchApiCallPost, dispatchApiCallPut, dispatchApiCallDelete } from '../../../../setup/redux/dispatch/actions'
import taxRate from "../../../../setup/redux/slices/taxRate";

import ServiceForm from "../../../v5/pages/services/Form";
import serviceSlice, { LocalGlobal } from "../../../v5/pages/services/slice";


const { saveUserCookieSettings } = actions;
const DropdownMenu = makeDropdownList(Button);


const StyledDropdownToggleText = styled.span`
    font-size: 14px;
`;
const StyledBadge = styled(Badge)`
    background-color: transparent;
    border: 1px solid #DFDFDF;
    font-weight: normal;
`;
const StyledTabButton = styled.button`
    background-color: transparent;
    color: #185CFF;
    border-bottom: 2px solid transparent;
    padding-bottom: 7px;

    &:hover {
        border-bottom: 2px solid #185CFF;
    }

    ${props => {
        if(props.active){
            return 'color: #484848; border-bottom: 2px solid #185CFF;';
        }
    }}
`;



const StyledFormCheck = styled(Form.Check)`
    position: relative;
    border-bottom: 1px solid #F5F5F5;
    min-height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .form-check-input[type=checkbox] {
        margin-left: 10px;
        border-radius: 0px;
        border: 0px;
        cursor: pointer;
        background-size: contain;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15'%3e%3cg id='Icon_ionic-ios-checkbox-outline' data-name='Icon ionic-ios-checkbox-outline' transform='translate(-2.5 -2.5)'%3e%3cpath id='Path_24397' data-name='Path 24397' d='M16.25,2.5H3.75A1.249,1.249,0,0,0,2.5,3.75v12.5A1.249,1.249,0,0,0,3.75,17.5h12.5a1.249,1.249,0,0,0,1.25-1.25V3.75A1.249,1.249,0,0,0,16.25,2.5Zm.156,13.594a.313.313,0,0,1-.312.313H3.906a.313.313,0,0,1-.312-.312V3.906a.313.313,0,0,1,.313-.312H16.094a.313.313,0,0,1,.313.313Z' fill='%23dfdfdf'/%3e%3cpath id='Path_24398' data-name='Path 24398' d='M14.2,7.535l-.687-.707a.148.148,0,0,0-.109-.047h0a.142.142,0,0,0-.109.047l-4.766,4.8L6.8,9.895a.151.151,0,0,0-.219,0l-.7.7a.156.156,0,0,0,0,.223L8.07,13a.692.692,0,0,0,.457.223.725.725,0,0,0,.453-.215h0l5.223-5.25A.167.167,0,0,0,14.2,7.535Z' fill='%23dfdfdf'/%3e%3c/g%3e%3c/svg%3e");
        
        &:checked{
            background-color: transparent;
            background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15'%3e%3cg id='Icon_ionic-ios-checkbox-outline' data-name='Icon ionic-ios-checkbox-outline' transform='translate(-2.5 -2.5)'%3e%3cpath id='Path_24397' data-name='Path 24397' d='M16.25,2.5H3.75A1.249,1.249,0,0,0,2.5,3.75v12.5A1.249,1.249,0,0,0,3.75,17.5h12.5a1.249,1.249,0,0,0,1.25-1.25V3.75A1.249,1.249,0,0,0,16.25,2.5Zm.156,13.594a.313.313,0,0,1-.312.313H3.906a.313.313,0,0,1-.312-.312V3.906a.313.313,0,0,1,.313-.312H16.094a.313.313,0,0,1,.313.313Z' fill='%23185cff'/%3e%3cpath id='Path_24398' data-name='Path 24398' d='M14.2,7.535l-.687-.707a.148.148,0,0,0-.109-.047h0a.142.142,0,0,0-.109.047l-4.766,4.8L6.8,9.895a.151.151,0,0,0-.219,0l-.7.7a.156.156,0,0,0,0,.223L8.07,13a.692.692,0,0,0,.457.223.725.725,0,0,0,.453-.215h0l5.223-5.25A.167.167,0,0,0,14.2,7.535Z' fill='%23185cff'/%3e%3c/g%3e%3c/svg%3e");
        }
    }

    label {
        position: relative;
        left: 10px;
        width: 100%;
        height: 100%;
        padding: 0px 10px 0px 0px;
        cursor: pointer;
        
        display: flex;
        align-items: center;
        
        width: 100%;
    
        ${(props) => {
            return props.isActive ? 'color: #185CFF;' : 'color: #FF0090;';
        }}

        &.text-secondary {
            color: #7B7B7B !important;
            font-size: 12px;
        }
    }

    .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
        opacity: 1;
    }

    ${(props) => {
        return props.active ? 'background-color: #ECF5DF;' : '';
    }}
`;
const StyledSortItem = styled(Dropdown.Item)`
    position: relative;
    display: flex;
    align-items: center;

    .custom-title {
        display: inline-block;
        flex-basis: 100%;
        width: 130px;
        white-space: pre-wrap;
        color: #484848;

        ${(props) => {
            return (props.active) ? 'font-weight: bold;' : '';
        }}
    }

    .custom-icons {
        display: inline-block;
        position: relative;
        width: 20px;
        height: 20px;
        overflow: hidden;
        background-color: transparent !important;

        .custom-icon-up {
            overflow: hidden;
            position: relative;
            height: 12px;

            > div {
                position: absolute;
                top: -6px;

                i {
                    ${(props) => {
                        return (props.active && props.direction == 'asc') ? 'color: #484848;' : 'color: #B8B8B8;';
                    }}

                    &:hover {
                        color: #484848;
                    }
                }
            }

            ${(props) => {
                return (props.active) ? 'display: block;' : 'display: none;';
            }}
        }

        .custom-icon-down {
            overflow: hidden;
            position: relative;
            height: 12px;

            > div {
                position: absolute;
                top: -9px;

                i {
                    ${(props) => {
                        return (props.active && props.direction == 'desc') ? 'color: #484848;' : 'color: #B8B8B8;';
                    }}

                    &:hover {
                        color: #484848;
                    }
                }
            }

            ${(props) => {
                return (props.active) ? 'display: block;' : 'display: none;';
            }}
        }
    }
    
    &.active, &:active, &:focus {
        ${(props) => {
            return props.active ? 'background-color: #ECECEC !important;' : 'background-color: transparent !important;';
        }}
    }

    &:hover {
        .custom-icons {
            .custom-icon-up {
                display: block;
            }
            .custom-icon-down {
                display: block;
            }
        }
    }
`;

const StyledNoResult = styled.div`
    max-width: 600px;
    height: 200px;
    background-color: #F0F7E5;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    margin: 50px auto;
`;


class CustomerLocalServices extends React.Component {
  
    constructor(props) {
        super(props);

        this.pageName = 'customer_local_service';
        this.backLink = '/Customers';

        this.pageIdField = "serviceItemId";
        this.pageCaption = 'Local Services'

        this.refForm = React.createRef();
        this.refCustomerForm = React.createRef();
        this.refLocalServiceForm = React.createRef();
        this.tableRef = React.createRef();
        this.refDataTableScrollSync = React.createRef();

        let id = Utils.getIntProps(props);
        
        let user = (props && props.auth && props.auth.user) ? props.auth.user : null;
        this.permissions = (user && user.permissions && user.permissions.length > 0) ? user.permissions : [];
        
        if(this.permissions && this.permissions.length > 0){
            if(this.permissions.findIndex(x => x.permissionId === PagesPermissions.CustomerServices.read) === -1){
                props.history.push('/Customer-overview-sites?id=' + id);
            }
        }

        
        this.getTaxInclusive = (row) => {
            let isTaxInclusive = (row && ((row.isTaxInclusive === true) || (row.isTaxInclusive === false))) ? row.isTaxInclusive : false;
            let invoiceTaxRate = (row && row.invoiceTaxRate) ? row.invoiceTaxRate : null;
            let purchaseTaxRate = (row && row.purchaseTaxRate) ? row.purchaseTaxRate : null;
            let taxRate = (invoiceTaxRate) ? Utils.formatNumber(invoiceTaxRate) : (purchaseTaxRate) ? Utils.formatNumber(purchaseTaxRate) : null;

            return (isTaxInclusive) ? (taxRate) ? 'YES (' + taxRate + '%)' : 'NO' : 'NO';
        };

        
        this.actionTemplate = (id, row, col, obj, index) => {
            return <IconButtonTable
            title={'Copy'}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
  
            //   this.setState({
            //     popupShowForm: true,
            //     popupLoadingForm: false,
            //     popupIdForm: row[this.pageIdField],
            //     popupIsCopyForm: true,
            //   });
              
                let customerId = Utils.getIntProps(this.props, 'id');
                this.props.action.serviceSlice.setShow({ show: true, customerId: customerId, id: row[this.pageIdField], isCopy: true, isLocalGlobal: LocalGlobal.LOCAL });
            }}
          >
            <i className={'material-icons'}>content_copy</i>
          </IconButtonTable>
        }

        const priceTemplate = (id, row, col, obj, index) => {
            return Utils.getCurrency() + Utils.formatNumber(row.price);
        };
        const priceExportTemplate = (row) => {
            return Utils.getCurrency() + Utils.formatNumber(row.price);
        };
        const priceExportCSVTemplate = (row) => {
            return Utils.getCurrency() + Utils.formatNumber(row.price);
        };

        const taxInclusiveTemplate = (id, row, col, obj, index) => {
            return this.getTaxInclusive(row);
        };
        const taxInclusiveExportTemplate = (row) => {
            return this.getTaxInclusive(row);
        };
        const taxInclusiveExportCSVTemplate = (row) => {
            return this.getTaxInclusive(row);
        };

        const priceBeforeTaxTemplate = (id, row, col, obj, index) => {
            let priceBeforeTax = (row && Utils.isNumber(row.priceBeforeTax)) ? row.priceBeforeTax : 0;
            return Utils.getCurrency() + Utils.formatNumber(priceBeforeTax)
        };
        const priceBeforeTaxExportTemplate = (row) => {
            let priceBeforeTax = (row && Utils.isNumber(row.priceBeforeTax)) ? row.priceBeforeTax : 0;
            return Utils.getCurrency() + Utils.formatNumber(priceBeforeTax)
        }
        const priceBeforeTaxExportCSVTemplate = (row) => {
            let priceBeforeTax = (row && Utils.isNumber(row.priceBeforeTax)) ? row.priceBeforeTax : 0;
            return Utils.getCurrency() + Utils.formatNumber(priceBeforeTax)
        }

        let columns = [
            { 
                id: this.pageIdField, 
                filterKey: this.pageIdField, 
                name: this.pageIdField, 
                label: 'ID',
                visible: false
            },
            {
                id: "customerName",
                detailsId: "customerName",
                name: "customerName",
                label: "CUSTOMER NAME",
                responsiveLabel: "CUSTOMER NAME",
                orderable: true,
            },
            {
                id: "serviceTag",
                detailsId: "serviceTag",
                name: "serviceTag",
                label: "SERVICE NAME",
                responsiveLabel: "SERVICE NAME",
                orderable: true,
            },
            {
                id: "wasteTypeName",
                detailsId: "wasteTypeName",
                name: "wasteTypeName",
                label: "WASTE TYPE",
                responsiveLabel: "WASTE TYPE",
                orderable: true,
            },
            {
                id: "binTypeName",
                detailsId: "binTypeName",
                name: "binTypeName",
                label: "BIN TYPE",
                responsiveLabel: "BIN TYPE",
                orderable: true,
            },
            {
                id: "price",
                detailsId: "price",
                name: "price",
                label: "RATE",
                responsiveLabel: "RATE",
                orderable: true,
                template: priceTemplate,
                exportTemplate: priceExportTemplate,
                exportCSVTemplate: priceExportCSVTemplate,
            },
            {
                id: "isTaxInclusive",
                detailsId: "isTaxInclusive",
                name: "isTaxInclusive",
                label: "Tax inclusive",
                responsiveLabel: "Tax inclusive",
                width: "150px",
                orderable: true,
                template: taxInclusiveTemplate,
                exportTemplate: taxInclusiveExportTemplate,
                exportCSVTemplate: taxInclusiveExportCSVTemplate,
            },
            { 
                id: 'priceBeforeTax', 
                detailsId: "priceBeforeTax",
                name: 'priceBeforeTax', 
                label: 'Amount Without Tax',
                width: '200px',
                filterable: false,
                orderable: true,
                template: priceBeforeTaxTemplate,
                exportTemplate: priceBeforeTaxExportTemplate,
                exportCSVTemplate: priceBeforeTaxExportCSVTemplate,
            },
            {
                id: "billingTypeDisplay",
                detailsId: "billingTypeDisplay",
                name: "billingType",
                label: "BILLING ACTION",
                responsiveLabel: "BILLING ACTION",
                orderable: true,
            },
            {
                id: "chargeCategoryName",
                detailsId: "chargeCategoryName",
                name: "chargeCategoryName",
                label: "BILLING CATEGORY",
                responsiveLabel: "BILLING CATEGORY",
                orderable: true,
            },
            {
                id: "description",
                detailsId: "description",
                name: "description",
                label: "DESCRIPTION",
                responsiveLabel: "DESCRIPTION",
                width: "150px",
                orderable: true,
            },

            { 
                id: 'action',
                filterKeyParam: 'action',
                name: 'action',
                label: '',
                width: '70px',
                responsiveLabel: '',
                orderable: false,
                exportVisible: false,
                visibleInDropdown: false,
                filterable: false,
                template: this.actionTemplate,
            }
        ];
        let initColumns = Array.from(columns);
        columns = Array.from(initColumns);
        
        
        let columnVisibility = [
            false,
            false,
            true,
            true,
            true,
            true,
            true,
            true,
            true,
            true,
            false,
            true
        ];
        let initColumnVisibility = Array.from(columnVisibility);
        columnVisibility = Array.from(initColumnVisibility);
    
        
        this.state = {
            id: id,
            details: null,
            mainLoading: false,
            
            popupShowCustomerForm: false,
            popupLoadingCustomerForm: false,
            popupIdCustomerForm: 0,
            popupIsCopyCustomerForm: false,

            popupShowLocalServiceForm: false,
            popupLoadingLocalServiceForm: false,
            popupIdLocalServiceForm: 0,
            popupIsCopyLocalServiceForm: false,

            popupShowForm: false,
            popupLoadingForm: false,
            popupIdForm: 0,
            popupIsCopyForm: false,

            leftItems: [],
            leftSearch: '',
            leftSortColumn: 'updated',
            leftSortDir: 'desc',
            leftCurrentPage: 1,
            leftPageSize: 30,
            leftTotal: 0,
            leftIsIncludeInactive: null,
            leftIsInactive: false,
            leftIsSearchDialog: false,
            sortColumnsLoading: false,
            sortColumns: SortColumns.customer,

            search: '',
            sortColumn: 'serviceTag',
            sortDir: 'desc',
            isIncludeInactive: null,
            isInactive: false,
            
            selected: [],
            columnVisibility: columnVisibility,
            initColumnVisibility: initColumnVisibility,
            columns: columns,
            initColumns: initColumns,
            rows: [],
            currentPage: 1,
            totalRows: 0,
            rowsPerPageSelected: 50,
            rowsPerPageOptions: [50, 100, 300],
            
            isDisabledBatchAction: true,
            isCookies: false,

            size: 0,
        };
    }


    componentDidMount(){
        this.setLayoutForm({
            leftHeaderContent: this.leftHeader,
            leftBodyContent: this.leftBody,
            rightHeaderContent: this.rightHeader,
            rightHeaderTabs: this.rightTabs,
            // onWindowResize: () => {
            //     this.getFilterInLocalStorage();
            // },
            onChangeSize: (size) => {
                this.setState({
                    size: size
                });
            },
        });

        this.getFilterInLocalStorage(() => {
            this.callInitApis();
        });
    }

    componentWillReceiveProps(nextProps) {
        this.reduxProps(nextProps);
    }


    /* API */
    reduxProps = nextProps => {
        Utils.reduxProps(nextProps,
            this.pageName + '-read', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let arr = [];
                if(data && data.data && data.data.length > 0){
                    arr = data.data.map((item, i) => {
                        return {
                            value: item.customerId,
                            title: item.customerName,
                            checked: false,
                            disabled: false,
                            active: (item.customerId === this.state.id) ? true : false,
                            isActive: item.isActive,
                            item: item,
                        }
                    });

                    arr = arr.sort((x, y) => {
                        return (x.active === y.active) ? 0 : x.active ? -1 : 1;
                    });
                }

                let total = (data && data.total) ? data.total : 0;

                this.setState({
                    leftTotal: total,

                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(callback){
                        callback(arr);
                    }
                });
            }
        );
        
        Utils.reduxProps(nextProps,
            this.pageName + '-read_more', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let arr = variables.items;

                if (data && data.data && data.data.length > 0) {
                    for (var i = 0; i < data.data.length; i++) {
                        let item = data.data[i];
                        let value = item.customerId;
                        let title = item.customerName;
                        let arrItem = {
                            value: value,
                            title: title,
                            checked: false,
                            disabled: false,
                            active: (item.customerId === this.state.id) ? true : false,
                            isActive: item.isActive,
                            item: item,
                        };

                        arr = Utils.addToArray(arr, value, arrItem);
                    }

                    arr = arr.sort((x, y) => {
                        return (x.active === y.active) ? 0 : x.active ? -1 : 1;
                    });
                }

                let total = (data && data.total) ? data.total : 0;

                this.setState({
                    leftItems: arr,
                    leftTotal: total,

                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(callback){
                        callback();
                    }
                });
            }
        );

        Utils.reduxProps(nextProps,
            this.pageName + '-read_services', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let arr = [];
                let total = 0;
                if(data && data.data && data.data.length > 0){
                    arr = data.data;
                    total = data.total;
                }

                this.setState({
                    rows: arr,
                    totalRows: total,

                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    this.setLoading(false);

                    if(callback){
                        callback(arr, total);
                    }
                });
            }
        );
    
        Utils.reduxProps(nextProps,
            this.pageName + '-bulk-update', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                this.setState({
                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(isError){
                        Utils.toast(<div style={{ fontWeight: 'bold' }}>{(err && err != '') ? err : 'An error has occurred'}</div>, 'error');
                    } else {
                        Utils.toast(<div style={{ fontWeight: 'bold' }}>{(data && data != '') ? data : 'Changes saved'}</div>, 'success');
                    }

                    if(callback){
                        callback(data, isError);
                    }
                });
            }
        );
    }
	
    callInitApis = () => {
        Utils.callAllApi([
            {
                api: readApi,
                path: 'customer',
                params: () => {
                    let data = {
                        currentPage: this.state.leftCurrentPage,
                        pageSize: this.state.leftPageSize,
                        searchQuery: this.state.leftSearch,
                        sortColumn: this.state.leftSortColumn,
                        sortDir: this.state.leftSortDir,
                    };
            
                    let leftIsIncludeInactive = ((this.state.leftIsIncludeInactive === true) || (this.state.leftIsIncludeInactive === false)) ? this.state.leftIsIncludeInactive : null;
                    if(leftIsIncludeInactive){
                        data['isIncludeInactive'] = leftIsIncludeInactive;
                    }

                    let leftIsInactive = ((this.state.leftIsInactive === true) || (this.state.leftIsInactive === false)) ? this.state.leftIsInactive : null;
                    if(leftIsInactive){
                        data['isInactive'] = leftIsInactive;
                    }

                    return data;
                },
                callback: (result) => {
                    Utils.parseResult(result, (data) => {
                        let arr = [];
                        if(data && data.data && data.data.length > 0){
                            arr = data.data.map((item, i) => {
                                return {
                                    value: item.customerId,
                                    title: item.customerName,
                                    checked: false,
                                    disabled: false,
                                    active: (item.customerId === this.state.id) ? true : false,
                                    isActive: item.isActive,
                                    item: item,
                                }
                            });

                            arr = arr.sort((x, y) => {
                                return (x.active === y.active) ? 0 : x.active ? -1 : 1;
                            });
                        }

                        let total = (data && data.total) ? data.total : 0;

                        this.setState({
                            leftItems: arr,
                            leftTotal: total,
                        }, () => {
                            this.refreshLayout();
                        });
                    });
                }
            },
            {
                api: readApi,
                path: 'customer/' + this.state.id,
                params: null,
                callback: (result) => {
                    Utils.parseResult(result, (data) => {
                        this.setState({
                            details: data,
                        }, () => {
                            this.refreshLayout();
                        });
                    });
                }
            },
            {
                api: readApi,
                path: 'service-item',
                params: () => {
                    let data = {
                        currentPage: this.state.currentPage,
                        pageSize: this.state.rowsPerPageSelected,
                        searchQuery: this.state.search,
                        sortColumn: this.state.sortColumn,
                        sortDir: this.state.sortDir,
                        customerId: this.state.id,
                        includeTaxRate: true,
                    };
            
                    let isIncludeInactive = ((this.state.isIncludeInactive === true) || (this.state.isIncludeInactive === false)) ? this.state.isIncludeInactive : null;
                    if(isIncludeInactive){
                        data['isIncludeInactive'] = isIncludeInactive;
                    }

                    let isInactive = ((this.state.isInactive === true) || (this.state.isInactive === false)) ? this.state.isInactive : null;
                    if(isInactive){
                        data['isInactive'] = isInactive;
                    }

                    return data;
                },
                callback: (result) => {
                    Utils.parseResult(result, (data) => {
                        let arr = [];
                        let total = 0;
                        if(data && data.data && data.data.length > 0){
                            arr = data.data;
                            total = data.total;
                        }

                        this.setState({
                            rows: arr,
                            totalRows: total,
                        }, () => {
                            this.refreshLayout();
                        });
                    });
                }
            }
        ], (result) => {
            this.setState({
                mainLoading: true,
            });

            this.setLoading(true);
        }, (results) => {
            this.setLoading(false);
            this.refreshLayout();
            
            this.setState({
                mainLoading: false,
            });
        });
    }

    callDetailsApis = (additionalParams = null) => {
        Utils.callAllApi([
            {
                api: readApi,
                path: 'customer/' + this.state.id,
                params: null,
                callback: (result) => {
                    Utils.parseResult(result, (data) => {
                        this.setState({
                            details: data,
                        }, () => {
                            this.refreshLayout();
                        });
                    });
                }
            },
            {
                api: readApi,
                path: 'service-item',
                params: () => {
                    let data = {
                        currentPage: this.state.currentPage,
                        pageSize: this.state.rowsPerPageSelected,
                        searchQuery: this.state.search,
                        sortColumn: this.state.sortColumn,
                        sortDir: this.state.sortDir,
                        customerId: this.state.id,
                    };
            
                    let isIncludeInactive = ((this.state.isIncludeInactive === true) || (this.state.isIncludeInactive === false)) ? this.state.isIncludeInactive : null;
                    if(isIncludeInactive){
                        data['isIncludeInactive'] = isIncludeInactive;
                    }

                    let isInactive = ((this.state.isInactive === true) || (this.state.isInactive === false)) ? this.state.isInactive : null;
                    if(isInactive){
                        data['isInactive'] = isInactive;
                    }

                    return data;
                },
                callback: (result) => {
                    Utils.parseResult(result, (data) => {
                        let arr = [];
                        let total = 0;
                        if(data && data.data && data.data.length > 0){
                            arr = data.data;
                            total = data.total;
                        }

                        this.setState({
                            rows: arr,
                            totalRows: total,
                        }, () => {
                            this.refreshLayout();
                        });
                    });
                }
            }
        ], (result) => {
            this.setState({
                mainLoading: true,
            });

            this.setLoading(true);
        }, (result) => {
            if(additionalParams){
                this.setState(additionalParams);
            }

            this.setLoading(false);
            this.refreshLayout();

            this.setState({
                mainLoading: false,
            });
        });
    }

    callReadApi = (callback = null) => {
        this.setLoading(true);
        
        let data = {
            currentPage: this.state.leftCurrentPage,
            pageSize: this.state.leftPageSize,
            searchQuery: this.state.leftSearch,
            sortColumn: this.state.leftSortColumn,
            sortDir: this.state.leftSortDir,
        };
   
        let leftIsIncludeInactive = ((this.state.leftIsIncludeInactive === true) || (this.state.leftIsIncludeInactive === false)) ? this.state.leftIsIncludeInactive : null;
        if(leftIsIncludeInactive){
            data['isIncludeInactive'] = leftIsIncludeInactive;
        }

        let leftIsInactive = ((this.state.leftIsInactive === true) || (this.state.leftIsInactive === false)) ? this.state.leftIsInactive : null;
        if(leftIsInactive){
            data['isInactive'] = leftIsInactive;
        }

        this.props.dispatchApiCallGet(data, this.pageName + '-read', 'customer', null, callback, () => {});
    }
    
    callReadMoreApi = (callback = null) => {
        this.setLoading(true);
        
        let data = {
            currentPage: this.state.leftCurrentPage,
            pageSize: this.state.leftPageSize,
            searchQuery: this.state.leftSearch,
            sortColumn: this.state.leftSortColumn,
            sortDir: this.state.leftSortDir,
        };
   
        let leftIsIncludeInactive = ((this.state.leftIsIncludeInactive === true) || (this.state.leftIsIncludeInactive === false)) ? this.state.leftIsIncludeInactive : null;
        if(leftIsIncludeInactive){
            data['isIncludeInactive'] = leftIsIncludeInactive;
        }

        let leftIsInactive = ((this.state.leftIsInactive === true) || (this.state.leftIsInactive === false)) ? this.state.leftIsInactive : null;
        if(leftIsInactive){
            data['isInactive'] = leftIsInactive;
        }

        this.props.dispatchApiCallGet(data, this.pageName + '-read_more', 'customer', { items: this.state.leftItems }, callback, () => {});
    }

    callReadServicesApi = (callback = null) => {
        this.setLoading(true);
        
        let data = {
            currentPage: this.state.currentPage,
            pageSize: this.state.rowsPerPageSelected,
            searchQuery: this.state.search,
            sortColumn: this.state.sortColumn,
            sortDir: this.state.sortDir,
            customerId: this.state.id,
        };
   
        let isIncludeInactive = ((this.state.isIncludeInactive === true) || (this.state.isIncludeInactive === false)) ? this.state.isIncludeInactive : null;
        if(isIncludeInactive){
            data['isIncludeInactive'] = isIncludeInactive;
        }

        let isInactive = ((this.state.isInactive === true) || (this.state.isInactive === false)) ? this.state.isInactive : null;
        if(isInactive){
            data['isInactive'] = isInactive;
        }

        this.props.dispatchApiCallGet(data, this.pageName + '-read_services', 'service-item', null, callback, () => {});
    }

    callBuldUpdateApi = (data, callback = null) => {
        this.setLoading(true);
        this.props.dispatchApiCallPut(data, this.pageName + '-bulk-update', 'service-item/bulk', data, callback, () => {});
    }
    /* END API */


    /* LAYOUT FUNCTIONS */
    setLayoutForm = (options) => {
        if(this.props.layoutRef && this.props.layoutRef.current){
            this.props.layoutRef.current.setLayoutForm(this, options);
        }
    }
    setLayoutLoading = (state = false) => {
        if(this.props.layoutRef && this.props.layoutRef.current){
            this.props.layoutRef.current.setLayoutLoading(state);
        }
    }
    refreshLayout = () => {
        if(this.props.layoutRef && this.props.layoutRef.current){
            this.props.layoutRef.current.refreshLayout();
        }
    }
    getLayoutObj = (options) => {
        if(this.props.layoutRef && this.props.layoutRef.current && this.props.layoutRef.current.obj && this.props.layoutRef.current.obj.current){
            return this.props.layoutRef.current.obj.current;
        }
    }
    /* END LAYOUT FUNCTIONS */


    /* FUNCTIONS */
    setLoading = (state = false) => {
        this.setLayoutLoading(state);

        if(this.props.onLoading){
            this.props.onLoading(state);
        }
    }

    setFilterInLocalStorage = (isCookies = true) => {
        if(this.props.settingsType >= 0){
            let { token, userCookieSettings } = this.props.auth;
        
            this.setState({
                isCookies: isCookies,
            });
            
            let data = {
                name: this.pageName,
                type: this.props.settingsType,
            };
        
            let valueLocalStorage = {
                [PageCookieSettingType.currentPage]: this.state.currentPage,
            };
            window.localStorage.setItem(this.pageName + '_' + this.props.settingsType, JSON.stringify(valueLocalStorage));
        
            let value = {
                [PageCookieSettingType.isCookies]: isCookies,
                // [PageCookieSettingType.search]: this.state.search,
                [PageCookieSettingType.sortColumn]: this.state.sortColumn,
                [PageCookieSettingType.sortDir]: this.state.sortDir,
                [PageCookieSettingType.rowsPerPageSelected]: this.state.rowsPerPageSelected,
                [PageCookieSettingType.columnVisibility]: this.state.columnVisibility,
                [PageCookieSettingType.columns]: this.state.columns,
                [PageCookieSettingType.isIncludeInactive]: this.state.isIncludeInactive,
                [PageCookieSettingType.isInactive]: this.state.isInactive,
                [PageCookieSettingType.leftIsIncludeInactive]: this.state.leftIsIncludeInactive,
                [PageCookieSettingType.leftIsInactive]: this.state.leftIsInactive,
            };
            data['value'] = JSON.stringify(value);
        
            Utils.saveUserCookieSettings(data, token, (settings) => {
                if(settings){
                    let settingsArr = (userCookieSettings && userCookieSettings.length > 0) ? userCookieSettings : [];
                    let settingsIndex = Utils.getUserCookieSettingsIndex(settingsArr, this.props.settingsType);
                    if(settingsIndex !== -1 && settingsArr[settingsIndex]){
                        settingsArr[settingsIndex] = settings;
                    } else {
                        settingsArr.push(settings);
                    }
            
                    this.props.saveUserCookieSettings(settingsArr)
                }
            });
        }
    };
    getFilterInLocalStorage = (callback = null) => {
        let settingsItem = null;
    
        if(this.props.settingsType >= 0){
            const { userCookieSettings } = this.props.auth;
        
            settingsItem = Utils.getUserCookieSettings(userCookieSettings, this.props.settingsType, this.pageName);
        }
    
        let valueLocalStorageStr = window.localStorage.getItem(this.pageName + '_' + this.props.settingsType);
        let valueLocalStorage = JSON.parse(valueLocalStorageStr);
        let currentPageValue = valueLocalStorage && valueLocalStorage[PageCookieSettingType.currentPage] && valueLocalStorage[PageCookieSettingType.currentPage] !== "" ? valueLocalStorage[PageCookieSettingType.currentPage] : this.state.currentPage;
        
        let isCookiesValue = settingsItem && settingsItem[PageCookieSettingType.isCookies] && settingsItem[PageCookieSettingType.isCookies] !== "" ? settingsItem[PageCookieSettingType.isCookies] : this.state.isCookies;
        let searchValue = (settingsItem && settingsItem[PageCookieSettingType.search] && settingsItem[PageCookieSettingType.search] !== '') ? settingsItem[PageCookieSettingType.search] : this.state.search;
        let sortColumnValue = settingsItem && settingsItem[PageCookieSettingType.sortColumn] && settingsItem[PageCookieSettingType.sortColumn] !== "" ? settingsItem[PageCookieSettingType.sortColumn] : this.state.sortColumn;
        let sortDirValue = settingsItem && settingsItem[PageCookieSettingType.sortDir] && settingsItem[PageCookieSettingType.sortDir] !== "" ? settingsItem[PageCookieSettingType.sortDir] : this.state.sortDir;
        let rowsPerPageSelectedValue = settingsItem && settingsItem[PageCookieSettingType.rowsPerPageSelected] && settingsItem[PageCookieSettingType.rowsPerPageSelected] !== "" ? settingsItem[PageCookieSettingType.rowsPerPageSelected] : this.state.rowsPerPageSelected;
        let columnVisibilityValue = (settingsItem && settingsItem[PageCookieSettingType.columnVisibility] && settingsItem[PageCookieSettingType.columnVisibility] !== '') ? settingsItem[PageCookieSettingType.columnVisibility] : this.state.columnVisibility;
        let columnsValue = (settingsItem && settingsItem[PageCookieSettingType.columns] && settingsItem[PageCookieSettingType.columns] !== '') ? settingsItem[PageCookieSettingType.columns] : this.state.columns;
        let isIncludeInactiveValue = (settingsItem && settingsItem[PageCookieSettingType.isIncludeInactive] && settingsItem[PageCookieSettingType.isIncludeInactive] !== '') ? settingsItem[PageCookieSettingType.isIncludeInactive] : this.state.isIncludeInactive;
        let isInactiveValue = (settingsItem && settingsItem[PageCookieSettingType.isInactive] && settingsItem[PageCookieSettingType.isInactive] !== '') ? settingsItem[PageCookieSettingType.isInactive] : this.state.isInactive;
        let leftIsIncludeInactiveValue = (settingsItem && settingsItem[PageCookieSettingType.leftIsIncludeInactive] && settingsItem[PageCookieSettingType.leftIsIncludeInactive] !== '') ? settingsItem[PageCookieSettingType.leftIsIncludeInactive] : this.state.leftIsIncludeInactive;
        let leftIsInactiveValue = (settingsItem && settingsItem[PageCookieSettingType.leftIsInactive] && settingsItem[PageCookieSettingType.leftIsInactive] !== '') ? settingsItem[PageCookieSettingType.leftIsInactive] : this.state.leftIsInactive;
        
        let columns = Utils.setTemplateFunctionsToColumns(this.state.columns, columnsValue);
        
        this.setState({
            isCookies: isCookiesValue,
            search: searchValue,
            sortColumn: sortColumnValue,
            sortDir: sortDirValue,
            currentPage: currentPageValue,
            rowsPerPageSelected: rowsPerPageSelectedValue,
            columnVisibility: columnVisibilityValue,
            isIncludeInactive: isIncludeInactiveValue,
            isInactive: isInactiveValue,
            leftIsIncludeInactive: leftIsIncludeInactiveValue,
            leftIsInactive: leftIsInactiveValue,
            columns: columns,
        }, () => {
            if (callback) {
                callback();
            }
        });
    };
    /* END FUNCTIONS */


    /* FORM */
    leftHeader = () => {
        return <Row className={'align-items-center gx-1'}>
            <Col xs={true}>
                <Dropdown alignRight>
                    <Dropdown.Toggle as={DropdownToggle} className={'px-0'}>
                        <StyledDropdownToggleText>{Utils.getAllActiveInactiveText(this.state.leftIsIncludeInactive, this.state.leftIsInactive)} Customers</StyledDropdownToggleText>
                        <ArrowDropDownIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            active={(this.state.leftIsIncludeInactive && this.state.leftIsInactive == null)}
                            onClick={() => {
                                this.setState({
                                    leftCurrentPage: 1,
                                    leftSearch: '',
                                    leftIsIncludeInactive: true,
                                    leftIsInactive: null,
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadApi((items) => {
                                        this.setState({
                                            leftItems: items,
                                        }, () => {
                                            this.setLoading(false);
                                            this.refreshLayout();
                                        });
                                    });
                                });
                            }}
                        >All</Dropdown.Item>
                        <Dropdown.Item
                            active={(this.state.leftIsIncludeInactive == null && !this.state.leftIsInactive)}
                            onClick={() => {
                                this.setState({
                                    leftCurrentPage: 1,
                                    leftSearch: '',
                                    leftIsIncludeInactive: null,
                                    leftIsInactive: false,
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadApi((items) => {
                                        this.setState({
                                            leftItems: items,
                                        }, () => {
                                            this.setLoading(false);
                                            this.refreshLayout();
                                        });
                                    });
                                });
                            }} 
                        >Active</Dropdown.Item>
                        <Dropdown.Item
                            active={(this.state.leftIsIncludeInactive == null && this.state.leftIsInactive)}
                            onClick={() => {
                                this.setState({
                                    leftCurrentPage: 1,
                                    leftSearch: '',
                                    leftIsIncludeInactive: null,
                                    leftIsInactive: true,
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadApi((items) => {
                                        this.setState({
                                            leftItems: items,
                                        }, () => {
                                            this.setLoading(false);
                                            this.refreshLayout();
                                        });
                                    });
                                });
                            }} 
                        >Inactive</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Col>
            <Col xs={'auto'}>
                <WrappedButton
                    className={'px-3 pe-1'}
                    variant={"primary"}
                    size={'sm'}
                    onClick={() => {
                        this.setState({
                          popupShowCustomerForm: true,
                          popupLoadingCustomerForm: false,
                          popupIdCustomerForm: 0,
                          popupIsCopyCustomerForm: false,
                        });
                    }}
                >
                    <i className={'material-icons'}>add</i>
                </WrappedButton>
            </Col>
            <Col xs={'auto'}>
                <Dropdown alignRight>
                    <Dropdown.Toggle
                        as={DropdownToggle}
                        isButton
                        className={'px-3 pe-1'}
                        variant={"light"}
                        size={'sm'}
                        style={{ backgroundColor: 'transparent' }}
                    >
                        <i className={'material-icons'}>format_list_bulleted</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Header>SORT BY</Dropdown.Header>

                        {this.state.sortColumns.map((item, i) => {
                            return <StyledSortItem
                                key={i}
                                active={(this.state.leftSortColumn == item.value) ? true : false}
                                direction={this.state.leftSortDir}
                                disabled={false}
                                onClick={() => {
                                    this.setState({
                                        sortColumnsLoading: true,
                                        leftCurrentPage: 1,
                                        leftSortColumn: item.value,
                                        leftSortDir: 'asc',
                                    }, () => {
                                        this.callReadApi((items) => {
                                            this.setState({
                                                sortColumnsLoading: false,
                                                leftItems: items,
                                            }, () => {
                                                this.setLoading(false);
                                                this.refreshLayout();
                                            });
                                        });
                                    });
                                }}
                            >
                                <div className={'custom-title'}>{item.title}</div>
                                <div className={'custom-icons'}>
                                    <div className={'custom-icon-up'}>
                                        <div>
                                            <i className={'material-icons ' + ((this.state.leftSortDir == 'asc') ? true : false)}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();

                                                    this.setState({
                                                        sortColumnsLoading: true,
                                                        leftCurrentPage: 1,
                                                        leftSortColumn: item.value,
                                                        leftSortDir: 'asc',
                                                    }, () => {
                                                        Utils.clickOutside();
                                                        this.callReadApi((items) => {
                                                            this.setState({
                                                                sortColumnsLoading: false,
                                                                leftItems: items,
                                                            }, () => {
                                                                this.setLoading(false);
                                                                this.refreshLayout();
                                                            });
                                                        });
                                                    });
                                                }}
                                            >arrow_drop_up</i>
                                        </div>
                                    </div>
                                    <div className={'custom-icon-down'}>
                                        <div>
                                            <i className={'material-icons ' + ((this.state.leftSortDir == 'desc') ? true : false)}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();

                                                    this.setState({
                                                        sortColumnsLoading: true,
                                                        leftCurrentPage: 1,
                                                        leftSortColumn: item.value,
                                                        leftSortDir: 'desc',
                                                    }, () => {
                                                        Utils.clickOutside();
                                                        this.callReadApi((items) => {
                                                            this.setState({
                                                                sortColumnsLoading: false,
                                                                leftItems: items,
                                                            }, () => {
                                                                this.setLoading(false);
                                                                this.refreshLayout();
                                                            });
                                                        });
                                                    });
                                                }}
                                            >arrow_drop_down</i>
                                        </div>
                                    </div>
                                </div>
                            </StyledSortItem>
                        })}
                        
                        <Dropdown.Divider />

                        <Dropdown.Item
                            active={false}
                            disabled={false}
                            onClick={() => {
                                this.setState({
                                    sortColumnsLoading: true,
                                    leftCurrentPage: 1,
                                    leftSearch: '',
                                    leftSortColumn: 'updated',
                                    leftSortDir: 'desc',
                                }, () => {
                                    this.callReadApi((items) => {
                                        this.setState({
                                            sortColumnsLoading: false,
                                            leftItems: items,
                                        }, () => {
                                            this.setLoading(false);
                                            this.refreshLayout();
                                        });
                                    });
                                });
                            }} 
                        >Refresh List</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Col>
            <Col xs={'auto'}>
                <WrappedButton
                    className={'px-3 pe-1'}
                    variant={"light"}
                    size={'sm'}
                    style={{ backgroundColor: 'transparent' }}
                    onClick={() => {
                        this.setState({
                            leftIsSearchDialog: true,
                        });
                    }}
                >
                    <i className={'material-icons'}>search</i>
                </WrappedButton>
            </Col>
            {this.leftClearSearch()}
        </Row>
    }

    leftBody = () => {
        return <div style={{ width: '100%' }}>
            {
            (this.state.leftItems && this.state.leftItems.length > 0)
            ?
            <>
                <InfiniteScroll
                    loader={<div key={0} className={'text-center pt-2'}><Spinner animation="border" size={'sm'} /></div>}
                    useWindow={false}
                    initialLoad={false}
                    getScrollParent={() => document.getElementById((window.innerWidth < 992) ? 'left_panel_1_ID' : 'left_panel_2_ID')}
                    threshold={1}

                    pageStart={1}
                    hasMore={((this.state.leftTotal > this.state.leftPageSize) && (this.state.leftItems.length < this.state.leftTotal))}

                    loadMore={(page) => {
                        if((this.state.leftTotal > this.state.leftPageSize) && (this.state.leftItems.length < this.state.leftTotal)){
                            this.setState({
                                leftCurrentPage: (this.state.leftCurrentPage+1)
                            }, () => {
                                this.callReadMoreApi(() => {
                                    this.setLoading(false);
                                    this.refreshLayout();
                                });
                            });
                        }
                    }}
                >
                    {
                        this.state.leftItems.map((item, i) => {
                            return <div key={i}
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    if(!item.active){
                                        this.setState({
                                            id: item.value,
                                            details: null,
                                        }, () => {
                                            this.props.history.push('/Customer-overview-local-services?id=' + this.state.id);
        
                                            this.state.leftItems.forEach(x => x.active = false);
                                            item.active = true;
                                            this.refreshLayout();
        
                                            this.callDetailsApis();
                                        });
                                    }
                                }}
                            >
                                <StyledFormCheck
                                    type={'checkbox'}
                                    active={item.active}
                                    isActive={item.isActive}
                                >
                                    <Row className={'align-items-center g-0'}>
                                        {/* <Col xs={'auto'}>
                                            <Form.Check.Input
                                                type={'checkbox'}
                                                checked={item.checked}
                                                disabled={item.disabled}
                                                onChange={(e) => {
                                                    item.checked = e.target.checked;
                                                    this.refreshLayout();
                                                }}
                                            />
                                        </Col> */}
                                        <Col xs={true}>
                                            <Row className={'align-items-center g-0'}>
                                                <Col xs={12}>
                                                    <Form.Check.Label
                                                        // onClick={(e) => {
                                                        //     if(!item.active){
                                                        //         this.setState({
                                                        //             id: item.value,
                                                        //             details: null,
                                                        //         }, () => {
                                                        //             this.props.history.push('/Customer-overview-local-services?id=' + this.state.id);
                                
                                                        //             this.state.leftItems.forEach(x => x.active = false);
                                                        //             item.active = true;
                                                        //             this.refreshLayout();
                                
                                                        //             this.callDetailsApis();
                                                        //         });
                                                        //     }
                                                        // }}
                                                    >{item.title}</Form.Check.Label>
                                                </Col>
                                                {!this.state.sortColumnsLoading && <Col xs={12}>
                                                    <Form.Check.Label
                                                        className={'text-secondary'}
                                                        onClick={(e) => {
                                                            if(!item.active){
                                                                this.setState({
                                                                    id: item.value,
                                                                    details: null,
                                                                }, () => {
                                                                    this.props.history.push('/Customer-overview-local-services?id=' + this.state.id);
                                
                                                                    this.state.leftItems.forEach(x => x.active = false);
                                                                    item.active = true;
                                                                    this.refreshLayout();
                                
                                                                    this.callDetailsApis();
                                                                });
                                                            }
                                                        }}
                                                    >{Utils.findSortItemTemplate(this.state.sortColumns, this.state.leftSortColumn, ((item && item.item) ? item.item : null))}</Form.Check.Label>
                                                </Col>}
                                            </Row>
                                        </Col>
                                    </Row>
                                </StyledFormCheck>
                            </div>
                        })
                    }
                </InfiniteScroll>
            
                
            {/* {((this.state.leftTotal > this.state.leftPageSize) && (this.state.leftItems.length < this.state.leftTotal)) && <div className={'pt-3 pb-3'}>
                <a href={'/'}
                    className={'link-primary'}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        
                        this.setState({
                            leftCurrentPage: (this.state.leftCurrentPage + 1)
                        }, () => {
                            this.callReadMoreApi(() => {
                                this.setLoading(false);
                                this.refreshLayout();
                            });
                        });
                    }}
                >
                    Show More
                </a>
            </div>} */}
            </>
            :
            <h6 className={'text-center pt-5 m-0'}>No Results!</h6>
            }
        </div>
    }

    leftClearSearch = () => {
        if(this.state.leftSearch !== ''){
            return <Col xs={12} className={'text-end'}>
                <a href={'/'}
                    className={'link-primary'}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        this.setState({
                            leftCurrentPage: 1,
                            leftSearch: '',
                            leftIsSearchDialog: false,
                        }, () => {
                            this.callReadApi((items, total) => {
                                this.setState({
                                    leftItems: items,
                                    leftTotal: total,
                                }, () => {
                                    this.setLoading(false);
                                    this.refreshLayout();
                                });
                            });
                        });
                    }}
                >
                    Clear Search
                </a>
            </Col>
        }
    }

    rightHeader = () => {
        if((this.state.id > 0) && this.state.details){
            return <Row className={'align-items-center justify-content-center justify-content-md-start py-5'}>
                <Col xs={'auto'}>
                    <h2 className={'m-0'}>{(this.state.details && this.state.details.customerName && this.state.details.customerName != '') ? this.state.details.customerName : <>&nbsp;</>}</h2>
                </Col>
                <Col xs={'auto'}>
                    {this.state.details && <StyledBadge 
                        pill 
                        className={'px-5 py-2'} 
                        bg={this.state.details.isActive ? 'default' : 'danger'}
                        text={this.state.details.isActive ? 'dark' : 'light'}
                    >
                        {this.state.details.isActive ? 'Active' : 'Inactive'}
                    </StyledBadge>}
                </Col>
            </Row>
        }
    }

    rightTabs = () => {
        if((this.state.id > 0) && this.state.details){
            return <Row className={'gx-md-0 gx-lg-5 align-items-center justify-content-center justify-content-md-start'}>
                {(Utils.hasPermission(this.permissions, PagesPermissions.CustomersOverview.read)) && <Col xs={'auto'}>
                    <StyledTabButton
                        active={false}
                        onClick={() => {
                            this.props.history.push('/Customer-overview?id=' + this.state.id);
                        }}
                    >Overview</StyledTabButton>
                </Col>}
                {(Utils.hasPermission(this.permissions, PagesPermissions.CustomerServices.read)) && <Col xs={'auto'}>
                    <StyledTabButton
                        active={true}
                        onClick={() => {

                        }}
                    >Local Service</StyledTabButton>
                </Col>}
                {(Utils.hasPermission(this.permissions, PagesPermissions.CustomerSites.read)) && <Col xs={'auto'}>
                    <StyledTabButton
                        active={false}
                        onClick={() => {
                            this.props.history.push('/Customer-overview-sites?id=' + this.state.id);
                        }}
                    >Sites</StyledTabButton>
                </Col>}
                {(Utils.hasPermission(this.permissions, PagesPermissions.CustomersEmail.read)) && <Col xs={'auto'}>
                    <StyledTabButton
                        active={false}
                        onClick={() => {
                            this.props.history.push('/Customer-overview-email?id=' + this.state.id);
                        }}
                    >Email Logs</StyledTabButton>
                </Col>}
            </Row>
        }
    }

    rightBodyNoResult = () => {
        if(this.state.id > 0){
            if(this.state.details){
                return <Row className={'gx-0'}>
                    <Col xs={12}>
                        {this.topSection(false)}
                    </Col>
                    <Col xs={12}>
                        <StyledNoResult>
                            <p className={'mb-5'}>
                                {
                                    this.state.search != ''
                                    ?
                                    "Sorry, there are no results for your search. To create, click \"+New\" button."
                                    :
                                    "You don't have local service for this customer. To create, click \"+New\" button."
                                }
                            </p>
                            <Button
                                variant={"primary"}
                                size={'sm'}
                                onClick={() => {
                                    // this.setState({
                                    //     popupShowLocalServiceForm: true,
                                    //     popupLoadingLocalServiceForm: false,
                                    //     popupIdLocalServiceForm: 0,
                                    //     popupIsCopyLocalServiceForm: false,
                                    // });

                                    let customerId = Utils.getIntProps(this.props, 'id');
                                    this.props.action.serviceSlice.setShow({ show: true, customerId: customerId, id: null, isCopy: false, isLocalGlobal: LocalGlobal.LOCAL });
                                }}
                            >
                                + New
                            </Button>
                        </StyledNoResult>
                    </Col>
                    <Col xs={12}>
                        <Row className={'justify-content-center'}>
                            <Col xs={12} sm={4} lg={3}>
                                <Row>
                                    <Col xs={'auto'} className={'pt-10'}>
                                        <LightbulbIcon />
                                    </Col>
                                    <Col xs={true}>
                                        <Row className={'pt-10 pb-10'}>
                                            <Col xs={12} className={'mb-2 fw-bold'}>Local Or Global Service</Col>
                                            <Col xs={12}>A Local Service is unique and applies to single customer whereas a&nbsp;
                                            <a href={'/services'} className={"link-primary"}>Global Service</a>
                                            &nbsp;is shared among all customers.</Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs={'auto'} className={'d-none d-sm-flex'}>
                                <div className={'vr'}></div>
                            </Col>
                            
                            <Col xs={12} sm={4} lg={3}>
                                <Row>
                                    <Col xs={'auto'} className={'pt-10'}>
                                        <LightbulbIcon />
                                    </Col>
                                    <Col xs={true}>
                                        <Row className={'pt-10 pb-10'}>
                                            <Col xs={12} className={'mb-2 fw-bold'}>When To Use Local Service</Col>
                                            <Col xs={12}>Use local when you wish to apply custom prices to this customer only. For example, all customers are billed $X price for service A but this customer is billed $Y price for the same service.</Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs={'auto'} className={'d-none d-lg-flex'}>
                                <div className={'vr'}></div>
                            </Col>

                            <Col xs={12} sm={8} lg={3}>
                                <Row>
                                    <Col xs={'auto'} className={'pt-10'}>
                                        <LightbulbIcon />
                                    </Col>
                                    <Col xs={true}>
                                        <Row className={'pt-10 pb-10'}>
                                            <Col xs={12} className={'mb-2 fw-bold'}>When To Use Global Service</Col>
                                            <Col xs={12}>
                                                <a href={'/services'} className={"link-primary"}>Global Service</a>
                                                &nbsp;is the default price that is shared among all your customers. For example, you have a common service fee item, billing all customers at $Y price.
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            } else {
                return <h5 className={'text-center mt-10 pt-10'}>The customer was not found</h5>
            }
        } else {
            return <h5 className={'text-center mt-10 pt-10'}>The customer doesn't exist</h5>
        }
    }

    rightBody = () => {
        return <Row className={'gx-0'}>
            <Col xs={12}>
                {this.topSection()}
            </Col>
            <Col xs={12}>
                {this.tableSection()}
            </Col>
            <Col xs={12}>
                {this.paginationSection()}
            </Col>
        </Row>
    }

    topSection = (state = true) => {
		return <ViewTopSection
            hasChecked={(!this.state.isDisabledBatchAction)}
            unchecked={this.topSectionUnchecked(state)}
            checked={this.topSectionChecked(state)}
        />
	}
	topSectionUnchecked = (state = true) => {
        return <Row className={"align-items-center"}>
            <Col xs={'auto'}>
                <Dropdown alignRight>
                    <Dropdown.Toggle as={DropdownToggle}>
                        <StyledDropdownToggleText>{Utils.getAllActiveInactiveText(this.state.isIncludeInactive, this.state.isInactive)} Local Services</StyledDropdownToggleText>
                        <ArrowDropDownIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            active={(this.state.isIncludeInactive && this.state.isInactive == null)}
                            onClick={() => {
                                this.setState({
                                    isIncludeInactive: true,
                                    isInactive: null,
                                    currentPage: 1,
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadServicesApi((rows, total) => {
                                        this.refreshLayout();
                                    });
                                });
                            }} 
                        >All</Dropdown.Item>
                        <Dropdown.Item
                            active={(this.state.isIncludeInactive == null && !this.state.isInactive)}
                            onClick={() => {
                                this.setState({
                                    isIncludeInactive: null,
                                    isInactive: false,
                                    currentPage: 1,
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadServicesApi((rows, total) => {
                                        this.refreshLayout();
                                    });
                                });
                            }} 
                        >Active</Dropdown.Item>
                        <Dropdown.Item
                            active={(this.state.isIncludeInactive == null && this.state.isInactive)}
                            onClick={() => {
                                this.setState({
                                    isIncludeInactive: null,
                                    isInactive: true,
                                    currentPage: 1,
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadServicesApi((rows, total) => {
                                        this.refreshLayout();
                                    });
                                });
                            }} 
                        >Inactive</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Col>

                <Col xs={'auto'}>
                    <CustomTooltip title={'Local service is a price list unique only to this customer.'}>
                        <InfoOutlinedIcon style={{ color: '#DFDFDF' }} />
                    </CustomTooltip>
                </Col>

                <Col xs={12} md={4} lg={3} className={'pb-2 pb-md-0'}>
                    <IconButtonSearch 
                        value={this.state.search}
                        isOpen={(this.state.search !== '') ? true : false}
                        onPressEnter={(value) => {
                            this.setState({
                                search: value,
                                currentPage: 1,
                            }, () => {
                                this.setFilterInLocalStorage();
                                this.callReadServicesApi((rows, total) => {
                                    this.refreshLayout();
                                });
                            });
                        }}
                        onClear={() => {
                            this.setState({
                                search: '',
                                currentPage: 1,
                            }, () => {
                                this.setFilterInLocalStorage();
                                this.callReadServicesApi((rows, total) => {
                                    this.refreshLayout();
                                });
                            });
                        }}
                    />
                </Col>

                <Col xs={true}></Col>

                {state && <Col xs={'auto'} className={'text-center'}>
                    <Button
                        size={"sm"}
                        onClick={() => {
                            // this.setState({
                            //     popupShowLocalServiceForm: true,
                            //     popupLoadingLocalServiceForm: false,
                            //     popupIdLocalServiceForm: 0,
                            //     popupIsCopyLocalServiceForm: false,
                            // });

                            let customerId = Utils.getIntProps(this.props, 'id');
                            this.props.action.serviceSlice.setShow({ show: true, customerId: customerId, id: null, isCopy: false, isLocalGlobal: LocalGlobal.LOCAL });
                        }}
                    >+ New</Button>
                </Col>}
                
                <Col xs={'auto'} className={'text-center'}>
                    <DropdownMenu
                        className={'px-3'}
                        variant={"light"}
                        size={"sm"}
                        text={<ViewHeadlineIcon />}
                    >
                        <DataTableActionMenu 
                            pageName={this.pageName}
                            columns={this.state.columns}
                            selected={this.state.rowsPerPageSelected}
                            selectItems={this.state.rowsPerPageOptions}
                            isCheckedIncludeInactive={this.state.isIncludeInactive}
                            columnVisibility={this.state.columnVisibility}
                            canSelectOption={false}
                            onChangeColumnVisibility={(index, value) => {
                                let colVis = this.state.columnVisibility;
                                colVis[index] = value;

                                this.setState({
                                    columnVisibility: colVis
                                }, () => {
                                    this.setFilterInLocalStorage();
                                });
                            }}
                            canInactive={false}
                            onSelectChangeAjax={(val) => {
                                this.setState({
                                    currentPage: 1,
                                    rowsPerPageSelected: val
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadServicesApi((rows, total) => {
                                        this.refreshLayout();
                                    });
                                });
                            }}
                            onChangeIncludeInactive={(val) => {
                                this.setState({
                                    isIncludeInactive: val,
                                    currentPage: 1,
                                }, () => {
                                    this.setFilterInLocalStorage();
                                    this.callReadServicesApi((rows, total) => {
                                        this.refreshLayout();
                                    });
                                });
                            }}
                            isCookies={this.state.isCookies}
                            onResetColumns={() => {
                                this.setState({
                                    columns: Array.from(this.state.initColumns),
                                    columnVisibility: Array.from(this.state.initColumnVisibility),
                                    sortColumn: this.state.sortColumnInit,
                                    sortDir: this.state.sortDirInit,
                                }, () => {
                                    this.setFilterInLocalStorage(false);
                                    this.callReadServicesApi((rows, total) => {
                                        this.refreshLayout();
                                    });
                                    if(this.refDropdownActionMenu && this.refDropdownActionMenu.current){
                                        this.refDropdownActionMenu.current.hide();
                                    }
                                });
                            }}
                            onShowMore={(isShowedMore) => {
                                this.setState({
                                    pageName: this.pageName,
                                });
                            }}
                        />
                    </DropdownMenu>
                </Col>

        </Row>
    }
	topSectionChecked = (state = true) => {
        return <Row className={"align-items-center"}>
            <Col xs={12} md={'auto'}>
                <Dropdown alignRight>
                    <Dropdown.Toggle>
                        Batch Action
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            active={false}
                            onClick={() => {
                                let selected = Utils.getSelected(this.tableRef);

                                let data = {
                                    ids: selected,
                                    isActive: true,
                                }

                                this.callBuldUpdateApi(data, () => {
                                    this.callReadServicesApi((rows, total) => {
                                        this.setState({
                                            isDisabledBatchAction: !this.state.isDisabledBatchAction,
                                        }, () => {
                                            Utils.setSelected(this.tableRef);
                                            this.refreshLayout();
                                        });
                                    });
                                });
                            }} 
                        >Mark As Active</Dropdown.Item>
                        <Dropdown.Item
                            active={false}
                            onClick={() => {
                                let selected = Utils.getSelected(this.tableRef);

                                let data = {
                                    ids: selected,
                                    isActive: false,
                                }

                                this.callBuldUpdateApi(data, () => {
                                    this.callReadServicesApi((rows, total) => {
                                        this.setState({
                                            isDisabledBatchAction: !this.state.isDisabledBatchAction,
                                        }, () => {
                                            Utils.setSelected(this.tableRef);
                                            this.refreshLayout();
                                        });
                                    });
                                });
                            }} 
                        >Mark As Inactive</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Col>
            <Col xs={12} md={true}>
                <span>{((this.tableRef && this.tableRef.current) ? this.tableRef.current.getSelected().length : '0')} item(s) selected</span>
            </Col>
        </Row>
    }
    
	tableSection = () => {
		return <DataTableScrollSync ref={this.refDataTableScrollSync} className={"table-sync-v4 with-details"}>{this.setDataTable()}</DataTableScrollSync>
	}
    setDataTable = () => {
        return <DataTable 
            ref={this.tableRef}

            className={"table-style-v4"}
            classNameWrapper={"table-v4"}

            pageName={this.pageName}
            rowId={this.pageIdField}
            caption={this.pageCaption}
            
            noMarginBottom={false}
            verticalAlign={'middle'}
            
            stickyHeader={false}
            isHeader={true}
            resizable={true}
            isDragableHeaderColumns={true}
            isDragable={false}
            isCheckbox={true}
            isBorder={false}
            isPagination={false}
            isVirtualize={false}
            
            columnVisibility={this.state.columnVisibility}
            disabledResizeColumns={[0]}

            isLoading={this.state.isLoading}
            rowsPerPageSelected={this.state.rowsPerPageSelected}
            rowsPerPageOptions={this.state.rowsPerPageOptions}

            search={this.state.search}
            rows={this.state.rows}
            columns={this.state.columns}
            details={this.setCustomDetails}

            onRowClick={(id, row) => {
                this.props.history.push('/Customer-local-service-overview?customerId=' + this.state.id + '&id=' + id);
            }}

            onRemove={(row) => {

            }}

            onClickCheckAll={(obj, checked, isDisabledBatchAction) => {
                this.setState({
                    isDisabledBatchAction: isDisabledBatchAction
                });
            }}
            onCheckRow={(obj, id, isDisabledBatchAction) => {
                this.setState({
                    isDisabledBatchAction: isDisabledBatchAction
                });
            }}
            
            onSortEnd={(columns, columnVisibility) => {
                this.setState({
                    columns: columns,
                    columnVisibility: columnVisibility,
                }, () => {
                    this.setFilterInLocalStorage();
                });
            }}
            onOrder={(name, sort) => {
                if(this.tableRef && this.tableRef.current){
                    this.tableRef.current.setSelected([], () => {
                        this.setState({
                            isDisabledBatchAction: true,
                        });
                    });
                }
                
                this.setState({
                    sortColumn: name,
                    sortDir: sort,
                }, () => {
                    this.setFilterInLocalStorage();
                    this.callReadServicesApi((rows, total) => {
                        this.refreshLayout();
                    });
                });
            }}
            onResize={(columns) => {
                if(columns){
                  this.setState({
                    columns: columns
                  });
                }
                this.setFilterInLocalStorage();
            }}
        />
    }

    setCustomDetails = (row, props, isItemSelected, obj) => {
        let bundleServices = (row && row.bundleServices && row.bundleServices.length > 0) ? row.bundleServices : [];
        
        if(bundleServices && bundleServices.length > 0){
            let isSelected = isItemSelected.isSelected(row[this.pageIdField], row);
            
          return bundleServices.sort((a: any, b: any) => a.order - b.order).map((details, d) => {
            let isLast = (d == (bundleServices.length-1)) ? true : false;

            return <TableRow key={d}
              className={'details-row custom-details-row-' + row[this.pageIdField] + ' exp-details-row exp-details' + (row.isLoading ? ' is-loading' : '') + (isSelected ? ' selected' : '') + (isLast ? ' is-last' : '') + ((row.isHover) ? ' hover' : '')}
              onClick={() => {
                this.props.history.push('/Customer-local-service-overview?customerId=' + this.state.id + '&id=' + row[this.pageIdField]);
              }}
            >
                <TableCell></TableCell>
                {(props.columns && props.columns.length > 0) && props.columns.map((col, k) => {
                    return col.visible === false ? null : props.columnVisibility[k] === false ? null : (
                    <TableCell key={k}>
                        {
                        (col.detailsId && col.detailsId !== '')
                        ?
                            (col.detailsId == 'price')
                            ?
                            Utils.getCurrency() + Utils.formatNumber(details.price)
                            :
                                (col.detailsId == 'priceBeforeTax')
                                ?
                                Utils.getCurrency() + Utils.formatNumber(details.priceBeforeTax)
                                :
                                    (col.detailsId == 'isTaxInclusive')
                                    ?
                                    this.getTaxInclusive(details)
                                    :
                                    details[col.detailsId]
                        :
                        ''
                        }
                    </TableCell>
                    );
                })}
            </TableRow>
          });
        }
    }

	paginationSection = () => {
		return <DataTableAjaxPagination
            style={{
                padding: '10px 0px',
                border: '0px',
                // left: this.state.size + 'px',
                // width: 'calc(100% - ' + this.state.size + 'px)'
                position: 'absolute',
                left: '0px',
                width: '100%',
            }}
            page={this.state.currentPage}
            selected={this.state.rowsPerPageSelected}
            count={this.state.totalRows}
            fixed={true}
            onPageChange={(page) => {
                this.setState({
                    currentPage: page,
                }, () => {
                    this.setFilterInLocalStorage();
                    this.callReadServicesApi((rows, total) => {
                        this.refreshLayout();
                    });
                });
            }}
            onOptionsChange={(option) => {
              this.setState({
                currentPage: 1,
                rowsPerPageSelected: option,
              }, () => {
                this.setFilterInLocalStorage();
                this.callReadServicesApi((rows, total) => {
                    this.refreshLayout();
                });
              });
            }}
        />
	}
    /* END FORM */


    /* DIALOG */
    setSearchDialog = () => {
        return <SearchDialog 
            show={this.state.leftIsSearchDialog}
            onCancel={() => {
                this.setState({
                    leftIsSearchDialog: false,
                });
            }}
            onSearch={(value) => {
                this.setState({
                    leftCurrentPage: 1,
                    leftSearch: value,
                    leftIsSearchDialog: false,
                }, () => {
                    this.callReadApi((items) => {
                        this.setState({
                            leftItems: items,
                        }, () => {
                            this.setLoading(false);
                            this.refreshLayout();
                        });
                    });
                });
            }}
        />
    }

    setPopupCustomerForm = () => {
        return <Popup 
            className={'no-bg'}
            auth={this.props.auth}
            settingsType={this.props.settingsType}

            show={this.state.popupShowCustomerForm}
            isLoading={this.state.popupLoadingCustomerForm}
            id={this.state.popupIdCustomerForm}
            isCopy={this.state.popupIsCopyCustomerForm}

            showHeader={true}
            header={this.state.popupIdCustomerForm ? this.state.popupIsCopyCustomerForm ? 'Copy Customer' : 'Edit Customer' : 'New Customer'}
            showFooter={true}
            centerFooter={'start'}
            footer={({ isLoading, id, onHide, onSave, onSaveCreateNewSite }) => {
                return <Row>
                    <Col xs={'auto'}>
                        <LoadingButton
                            isLoading={isLoading}
                            onClick={onSave}
                        >Save</LoadingButton>
                    </Col>

                    {(!id) && <Col xs={'auto'}>
                        <Button 
                            type={'button'}
                            variant={'primary'}
                            disabled={isLoading}
                            onClick={onSaveCreateNewSite}
                        >
                            Save & Create New Site
                            {isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
                        </Button>
                    </Col>}

                    <Col xs={'auto'}>
                        <Button
                            variant={'light'}
                            disabled={isLoading}
                            onClick={onHide}
                        >Cancel</Button>
                    </Col>
                </Row>
            }}

            scrollable={true}
            centered={true}
            closeButton={true}
            fullscreen={true}
            noBodyPadding={true}

            onHide={() => {
                this.setState({
                    popupShowCustomerForm: false,
                    popupLoadingCustomerForm: false,
                    popupIdCustomerForm: 0,
                    popupIsCopyCustomerForm: false,
                });
            }}
            onSave={() => {
                if(this.refCustomerForm && this.refCustomerForm.current){
                    if(this.refCustomerForm.current.refForm && this.refCustomerForm.current.refForm.current){
                        this.refCustomerForm.current.refForm.current.handleSubmit();
                    }
                }
            }}
            onSaveCreateNewSite={() => {
                if(this.refCustomerForm && this.refCustomerForm.current){
                    if(this.refCustomerForm.current.onSaveCreateNewSite){
                        this.refCustomerForm.current.onSaveCreateNewSite((res) => {
                            this.props.history.push({
                                pathname: '/Customer-overview-sites',
                                search: '?id=' + res.customerId,
                                state: { showNewPopup: true },
                            });
                        });
                    }
                }
            }}
            
            onLoading={(state) => {
                this.setState({
                    popupLoadingCustomerForm: state,
                });
            }}
            onSubmit={(form) => {
                this.setState({
                    popupShowCustomerForm: false,
                    popupLoadingCustomerForm: false,
                    popupIdCustomerForm: 0,
                    popupIsCopyCustomerForm: false,
                    details: null,
                }, () => {
                    this.callReadApi((items) => {
                        this.setState({
                            leftItems: items,
                        }, () => {
                            this.setLoading(false);
                            this.refreshLayout();
                        });
                    });

                    this.callDetailsApis();
                });
            }}
        >
            {(props) => {
                return <CustomerForm
                    ref={this.refCustomerForm}
                    {...props}
                />
            }}
        </Popup>
    }

    setPopupLocalServiceForm = () => {
        return <Popup 
            className={'no-bg'}
            auth={this.props.auth}
            settingsType={this.props.settingsType}

            customerId={this.state.id}

            show={this.state.popupShowLocalServiceForm}
            isLoading={this.state.popupLoadingLocalServiceForm || this.props.taxRate.isLoading}
            id={this.state.popupIdLocalServiceForm}
            isCopy={this.state.popupIsCopyLocalServiceForm}
            
            showHeader={true}
            header={this.state.popupIdLocalServiceForm ? this.state.popupIsCopyLocalServiceForm ? 'Copy Local Service' : 'Edit Local Service' : 'Add Local Service'}
            showFooter={true}
            centerFooter={'start'}
            footer={({ isLoading, id, onHide, onSave }) => {
                return <Row style={{ width: '100%' }}>
                    <Col xs={'auto'}>
                        <LoadingButton
                            isLoading={isLoading}
                            onClick={onSave}
                        >Save</LoadingButton>
                    </Col>
                    <Col xs={'auto'}>
                        <Button
                            variant={'light'}
                            disabled={isLoading}
                            onClick={onHide}
                        >Cancel</Button>
                    </Col>
                </Row>
            }}

            scrollable={true}
            centered={true}
            closeButton={true}
            fullscreen={true}
            noBodyPadding={true}

            onHide={() => {
                this.setState({
                    popupShowLocalServiceForm: false,
                    popupLoadingLocalServiceForm: false,
                    popupIdLocalServiceForm: 0,
                    popupIsCopyLocalServiceForm: false,
                });
            }}
            onSave={() => {
                if(this.refLocalServiceForm && this.refLocalServiceForm.current){
                    if(this.refLocalServiceForm.current.refForm && this.refLocalServiceForm.current.refForm.current){
                        this.refLocalServiceForm.current.refForm.current.handleSubmit();
                    }
                }
            }}
            
            onLoading={(state) => {
                this.setState({
                    popupLoadingLocalServiceForm: state,
                });
            }}
            onSubmit={(form) => {
                this.setState({
                    popupShowLocalServiceForm: false,
                    popupLoadingLocalServiceForm: false,
                    popupIdLocalServiceForm: 0,
                    popupIsCopyLocalServiceForm: false,
                    details: null,
                }, () => {
                    this.callInitApis();
                });
            }}
        >
            {(props) => {
                return <LocalServiceForm
                    ref={this.refLocalServiceForm}
                    {...props}
                />
            }}
        </Popup>
    }

    setPopupForm = () => {
        return <Popup 
            className={'no-bg'}
            auth={this.props.auth}
            settingsType={this.props.settingsType}

            customerId={this.state.id}

            show={this.state.popupShowForm}
            isLoading={this.state.popupLoadingForm || this.props.taxRate.isLoading}
            id={this.state.popupIdForm}
            isCopy={this.state.popupIsCopyForm}
            
            showHeader={true}
            header={this.state.popupIdForm ? this.state.popupIsCopyForm ? 'Copy Local Service' : 'Edit Local Service' : 'Add Local Service'}
            showFooter={true}
            centerFooter={'start'}
            footer={({ isLoading, id, isCopy, onHide, onSave, onApplayAllSites, onRemove, onCopy }) => {
                return <Row style={{ width: '100%' }}>
                    <Col xs={'auto'}>
                        <LoadingButton
                            isLoading={isLoading}
                            onClick={onSave}
                        >Save</LoadingButton>
                    </Col>
                    <Col xs={'auto'}>
                        <Button
                            variant={'light'}
                            disabled={isLoading}
                            onClick={onHide}
                        >Cancel</Button>
                    </Col>
                </Row>
            }}

            scrollable={true}
            centered={true}
            closeButton={true}
            fullscreen={true}
            noBodyPadding={true}

            onApplayAllSites={() => {
                if(this.refForm && this.refForm.current){
                    this.refForm.current.onApplayAllSites();
                }
            }}

            onHide={() => {
                this.setState({
                    popupShowForm: false,
                    popupLoadingForm: false,
                    popupIdForm: 0,
                    popupIsCopyForm: false,
                });
            }}
            onSave={() => {
                if(this.refForm && this.refForm.current){
                    if(this.refForm.current.refForm && this.refForm.current.refForm.current){
                        this.refForm.current.refForm.current.handleSubmit();
                    }
                }
            }}
            onRemove={() => {
                if(this.refForm && this.refForm.current){
                    this.refForm.current.handleRemove();
                }
            }}
            onCopy={() => {
                let id = this.state.popupIdForm;

                this.setState({
                    popupShowForm: false,
                    popupLoadingForm: false,
                    popupIdForm: 0,
                    popupIsCopyForm: false,
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            popupShowForm: true,
                            popupLoadingForm: true,
                            popupIdForm: id,
                            popupIsCopyForm: true,
                        });
                    }, 500);
                });
            }}
            
            onLoading={(state) => {
                this.setState({
                    popupLoadingForm: state,
                });
            }}
            onSubmit={(form) => {
                this.setState({
                    popupShowForm: false,
                    popupLoadingForm: false,
                    popupIdForm: 0,
                    popupIsCopyForm: false,
                    details: null,
                }, () => {
                    this.callInitApis();
                });
            }}
        >
            {(props) => {
                return <LocalServiceForm
                    ref={this.refForm}
                    {...props}
                />
            }}
        </Popup>
    }
    /* END DIALOG */


    render() {
        return <>
            <Row style={{ display: 'contents', width: '100%' }}>
                <Col xs={12} className={'p-0'}>
                    {this.state.mainLoading ? null : (this.state.details && (this.state.rows && this.state.rows.length > 0)) ? this.rightBody() : this.rightBodyNoResult()}
                </Col>
            </Row>
            {this.setSearchDialog()}
            {this.setPopupCustomerForm()}
            {/* {this.setPopupLocalServiceForm()} */}
            {/* {this.setPopupForm()} */}

            <ServiceForm
                onSave={(data: any) => {
                    this.callInitApis();
                }}
            />
        </>
    }
}


const mapStateToProps = state => {
    return {
      ...state,
      ...Utils.mapStateToProps(state),
    };
};
const mapDispatchToProps = (dispatch) => ({
    dispatchApiCallGet: (p1, p2, p3, p4, p5, p6) => dispatch(dispatchApiCallGet(p1, p2, p3, p4, p5, p6)),
    dispatchApiCallPost: (p1, p2, p3, p4, p5, p6) => dispatch(dispatchApiCallPost(p1, p2, p3, p4, p5, p6)),
    dispatchApiCallPut: (p1, p2, p3, p4, p5, p6) => dispatch(dispatchApiCallPut(p1, p2, p3, p4, p5, p6)),
    dispatchApiCallDelete: (p1, p2, p3, p4, p5, p6) => dispatch(dispatchApiCallDelete(p1, p2, p3, p4, p5, p6)),
    saveUserCookieSettings: (payload) => dispatch(saveUserCookieSettings(payload)),
    clear: (payload) => dispatch(clear(payload)),
    action: {
        serviceSlice: {
            setShow: (payload) => dispatch(serviceSlice.setShow(payload)),
        },
    }
});
  
  
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(CustomerLocalServices);
